import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3655eff9&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bratej/Kreatorij/vz-landing-svetovanje/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3655eff9')) {
      api.createRecord('3655eff9', component.options)
    } else {
      api.reload('3655eff9', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=3655eff9&", function () {
      api.rerender('3655eff9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/Pages/Index.vue"
export default component.exports